function Head (){
    return null;
}

export default Head;
